import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  selectInputStyle: {
    border: "1px solid #93A9BD",
    background: "#fff",
    color: "#465869",
    boxSizing: "border-box",
    height: "32px",
    width: "129px",
    position: "relative",
    textIndent: "3.3rem",
    paddingLeft: ".8rem",
  },
  suppliersGridWrapper: {
    "& .top-panel": {
      alignItems: "flex-start",
      "& .left-side": {
        alignItems: "flex-start",
        "& .children-container": {
          alignSelf: "flex-start",
          alignItems: "flex-start",
        },
      },
      "& .search-container": {
        "& .search-input": {
          "& .input-container": {
            height: "38px",
            "& .search-icon-container": {
              height: "37px",
            },
          },
        },
      },
    },
  },
  spanCustomerSelect: {
    position: "absolute",
    left: "8px",
    top: 5,
    color: "#9ca6af",
  },

  alignTextLeft: {
    textAlign: "left",
  },

  alignCapitalizedText: {
    textAlign: "left",
    textTransform: "capitalize",
  },
  actionIcon: {
    cursor: "pointer",
    marginLeft: "3px",
  },
  buttonInvite: {
    display: "flex",
    alignItems: "center",
    "& span": {
      whiteSpace: "nowrap",
      marginLeft: "8px",
    },
  },
  button: {
    cursor: "pointer",
  },
  noWhiteSpace: {
    whiteSpace: "nowrap",
  },
}));

export default styles;
